export enum BrandingImageName {
  logo = 'logo',
  backgroundImage = 'backgroundImage',
}
export type TImageName = BrandingImageName.logo | BrandingImageName.backgroundImage;
export type TBrandingImage = { id: number; url: string };

export enum BgOptions {
  empty = 'empty',
  alycePattern = 'alycePattern',
  bgImage = 'bgImage',
  noPattern = 'noPattern',
}

export interface IUploadImageParams {
  name: TImageName;
  file: File;
}

export interface IChangeImageParams {
  name: TImageName;
  image: TBrandingImage;
}
